import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=b353e520&scoped=true&lang=pug&"
import script from "./AccountForm.vue?vue&type=script&lang=js&"
export * from "./AccountForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=b353e520&lang=scss&scoped=true&"
import style1 from "./AccountForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b353e520",
  null
  
)

export default component.exports